import { mapState } from 'vuex'

export default {
    props: {
        index: {
            type: Number,
            default: 0
        },
    },

    data() {
        return {
            contract: 'portability',
            number: null,
            numberHasError: false,
        }
    },

    watch: {
        showStepErrors: function(show) {
            if(show) this.numberHasError = !this.validate()
            else this.numberHasError = false
        }
    },

    mounted() {
        // broadcast default config
        this.emitConfig()
    },

    methods: {
        contractChange() {
            this.number = null
            this.emitConfig()
        },

        numberChange() {
            if(this.showStepErrors) this.numberHasError = !this.validate()
            this.emitConfig()
        },

        emitConfig() {
            this.$emit('config', {
                contract: this.contract,
                number: this.number,
                valid: this.validate()
            })
        },

        validate() {
            if(this.contract === 'portability') return this.validateCellNumber()
            return this.contract === 'new';
        },

        validateCellNumber() {
            let re = /^(6|7)[0-9]{8}$/
            return re.test(this.number)
        },
    },

    computed: {
        ...mapState('steps', {
                showStepErrors: state => state.one.showErrors,
        }),

        isNotValid() {
            return !this.validate()
        }
    }
}
